import './App.css';

import Navbar from './components/NavBar';
import FloatingSidebar from './components/FloatingSidebar';
import FooterNew from './components/FooterNew';

import Header from './components/Header';
import Master from './components/Master';
import Trailer from './components/Trailer';
import StudyMethod from './components/StudyMethod';
import NewStudyMethod from './components/NewStudyMethod';
import Memberships from './components/Memberships';
import Financing from './components/Financing';
import Counseling from './components/Counseling';
import FeaturedResults from './components/FeaturedResults';
import FAQ from './components/FAQ';
import HeaderForm from './components/HeaderForm';

import Plans from './components/Plans';
import Brands from './components/Brands';
import Gallery from './components/Gallery';

function App() {
	return (
		<main className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<Header />
			<Master />
			{/* <Trailer /> */}
			{/* <StudyMethod /> */}
			<NewStudyMethod />
			<Gallery />
			<HeaderForm />
			{/* <Plans /> */}
			{/* <Financing /> */}
			<Brands />
			<Counseling />
			{/* <FeaturedResults /> */}
			<FAQ />
			<FooterNew />
		</main>
	);
}

export default App;
